import { InformNotificationPopup } from '@aibees/elephant/components/inform-notification-popup';
import {
  ComingSoonTag,
  Icon,
  Label,
  RHFCheckbox,
} from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ContactItemProps as Props } from './types';
import { SaveRecordAction } from '@aibees/elephant/hooks';
import { BouncebanChip } from '@aibees/shared/components';

export const ContactItem = memo(({ className, item }: Props) => {
  const {
    disabled,
    icon,
    title,
    value,
    infoDisabled,
    comingSoon,
    mandatory,
    done: _done,
    notificationDescription,
  } = item;

  const showBounceban =
    value === SaveRecordAction.CONTACT_ENRICH_EMAIL ||
    value === SaveRecordAction.CONTACT_REVERIFY_EMAIL;

  return (
    <Styled.Wrapper
      className={classnames('ContactItem', className)}
      sx={SX.root}
    >
      <RHFCheckbox name={value} label="" disabled={disabled} size="medium" />
      <Box sx={SX.content}>
        <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
          <Icon name={icon} size={18} sxx={SX.icon} />
          <Typography sx={SX.title}>{title}</Typography>

          {mandatory && <Label sx={SX.mandatory}>Mandatory</Label>}
          {comingSoon && <ComingSoonTag />}
        </Box>

        {(notificationDescription || showBounceban) && (
          <Stack direction="row" alignItems="center" gap={0.5}>
            {showBounceban && <BouncebanChip />}
            <InformNotificationPopup disabled={infoDisabled}>
              {notificationDescription}
            </InformNotificationPopup>
          </Stack>
        )}
      </Box>
    </Styled.Wrapper>
  );
});

ContactItem.displayName = 'ContactItem';
